import {
  Text,
  IconBanknote,
  GreyGrey10,
  GreyGrey50,
  GreyGrey70,
  Primary12SemiBold,
  Primary16SemiBold,
  Primary16Regular,
  Primary24SemiBold,
  Box,
  Flex
} from '@sequencehq/core-components'
import { Address, Currency } from '@sequencehq/api'
import { DashboardApi20240730 } from '@sequencehq/api/dashboard/v20240730'
import { toMoney } from '@sequencehq/utils'
import { BankDetails } from 'PaymentsApp/components/BankDetails'
import { FC } from 'react'
import { useSearchParams } from 'react-router-dom'

interface BankTransferParams {
  invoiceNumber: string
  total: string
  currency: Currency
  ukAccountDetails?: DashboardApi20240730.SequenceAccount.SortCodeAccountNumber
  iban?: string
  usAchDestination?: DashboardApi20240730.SequenceAccount.UsAchDestination
  usWireDestination?: DashboardApi20240730.SequenceAccount.UsWireDestination
  caBankAccountDestination?: DashboardApi20240730.SequenceAccount.CanadianDestination
  canadianInternationalDestination?: DashboardApi20240730.SequenceAccount.CanadianInternationalDestination
  merchantLegalCompanyName: string
  merchantAddress: Address
  includeBeneficiaryAddressInPaymentDetails: boolean
}

const BankTransfer: FC<BankTransferParams> = ({
  invoiceNumber,
  total,
  currency,
  ukAccountDetails,
  iban,
  usAchDestination,
  usWireDestination,
  caBankAccountDestination,
  canadianInternationalDestination,
  merchantLegalCompanyName,
  merchantAddress,
  includeBeneficiaryAddressInPaymentDetails
}) => {
  return (
    <Flex alignItems="center" justifyContent="center">
      <Box margin="auto" width="380px">
        <Box height="192px" />
        <Flex
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          textAlign="center"
        >
          <IconBanknote size={36} color={GreyGrey50} />
          <Text {...Primary24SemiBold}>Invoice {invoiceNumber}</Text>
          <Box height="18px" />
          <Flex flexDirection="row">
            <Text {...Primary16Regular}>Total due</Text>
            <Box width="6px"></Box>
            <Text {...Primary16SemiBold}>
              {toMoney({
                currency: currency,
                value: total
              })}
            </Text>
          </Flex>
        </Flex>
        <Box height="36px" />
        <Flex
          justifyContent="center"
          flexDirection="column"
          backgroundColor={GreyGrey10}
          borderRadius="12px 12px 12px 12px"
          padding="16px"
        >
          <Text
            {...Primary12SemiBold}
            color={GreyGrey70}
            textTransform="uppercase"
            marginBottom="8px"
          >
            Bank details
          </Text>

          <BankDetails
            ukAccountDetails={ukAccountDetails}
            iban={iban}
            usAchDestination={usAchDestination}
            usWireDestination={usWireDestination}
            caBankAccountDestination={caBankAccountDestination}
            canadianInternationalDestination={canadianInternationalDestination}
            merchantLegalCompanyName={merchantLegalCompanyName}
            merchantAddress={merchantAddress}
            includeBeneficiaryAddressInPaymentDetails={
              includeBeneficiaryAddressInPaymentDetails
            }
          />
        </Flex>
        <Box height="20px"></Box>
      </Box>
    </Flex>
  )
}

export const BankTransferParamsHandler: FC = () => {
  const [searchParams] = useSearchParams()
  const invoiceDetails: BankTransferParams = JSON.parse(
    atob(searchParams.get('invoiceDetails') || '')
  )
  return (
    <BankTransfer
      invoiceNumber={invoiceDetails.invoiceNumber}
      total={invoiceDetails.total}
      currency={invoiceDetails.currency}
      ukAccountDetails={invoiceDetails.ukAccountDetails}
      iban={invoiceDetails.iban}
      usAchDestination={invoiceDetails.usAchDestination}
      usWireDestination={invoiceDetails.usWireDestination}
      caBankAccountDestination={invoiceDetails.caBankAccountDestination}
      canadianInternationalDestination={
        invoiceDetails.canadianInternationalDestination
      }
      merchantAddress={invoiceDetails.merchantAddress}
      merchantLegalCompanyName={invoiceDetails.merchantLegalCompanyName}
      includeBeneficiaryAddressInPaymentDetails={
        invoiceDetails.includeBeneficiaryAddressInPaymentDetails
      }
    />
  )
}
